// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"9d884407","299":"58f9b78e","353":"76f06e73","435":"d2ab15ab","453":"d21a3157"}[chunkId] + ".chunk.js";
};